import posthog from "posthog-js";

export const track = (event: string, props?: Record<string, unknown>): void => {
  if (!import.meta.env.PROD) return;
  posthog.capture(event, props);
};
